import { appEnvironment } from './environment';

export const CONSENT_SECTIONS = {
  HEALTH_DATA: '4-1',
  RESEARCH: '7-7',
} as const;

export const LEGAL_URLS = {
  syd: {
    memberTerms: 'https://syd.life/terms/user_terms.html',
    acceptableUsePolicy: 'https://syd.life/terms/use_policy.html',
    privacyNoticeEn: 'https://syd.life/terms/privacy_notice.html',
    privacyNoticeJa: 'https://syd.life/terms/privacy_notice_ja.html',
  },
  altius: {
    memberTerms: 'https://www.altiusco.com/terms-conditions',
    acceptableUsePolicy: 'https://www.altiusco.com/terms-conditions',
    privacyNoticeEn: 'https://www.altiusco.com/privacy-policy',
    privacyNoticeJa: 'https://www.altiusco.com/privacy-policy',
  },
} as const;

export interface LegalUriOptions {
  isJa: boolean;
  language: string;
  section?: string;
}

const isSydBrand = () => appEnvironment.theme.appName.toLowerCase() === 'syd';

export const getMemberTermsURI = ({
  isJa,
  language,
  section,
}: LegalUriOptions) => {
  const isSyd = isSydBrand();
  const base = isSyd
    ? LEGAL_URLS.syd.memberTerms
    : LEGAL_URLS.altius.memberTerms;
  const localized = isJa
    ? `${base}?lng=ja-JP`
    : language === 'ar'
    ? `${base}?lng=ar-001`
    : base;

  return section ? `${localized}#section-${section}` : localized;
};

export const getAcceptableUsePolicyURI = ({
  isJa,
  language,
}: LegalUriOptions) => {
  const isSyd = isSydBrand();
  const base = isSyd
    ? LEGAL_URLS.syd.acceptableUsePolicy
    : LEGAL_URLS.altius.acceptableUsePolicy;

  return isJa
    ? `${base}?lng=ja-JP`
    : language === 'ar'
    ? `${base}?lng=ar-001`
    : base;
};

export const getPrivacyNoticeURI = ({
  isJa,
  language,
  section,
}: LegalUriOptions) => {
  const isSyd = isSydBrand();

  if (!isSyd) {
    const base = LEGAL_URLS.altius.privacyNoticeEn;
    return section ? `${base}#section-${section}` : base;
  }

  // Syd language-specific routing
  const base = isJa
    ? LEGAL_URLS.syd.privacyNoticeJa
    : LEGAL_URLS.syd.privacyNoticeEn;
  const localized = language === 'ar' ? `${base}?lng=ar-001` : base;

  return section ? `${localized}#section-${section}` : localized;
};
